import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { AuthPartialState, User } from './auth.reducer';
import { authQuery } from './auth.selectors';
import { Login, GetUserDetails, Logout } from './auth.actions';
import { JwtService } from '@ecosure-suite/shared/util-auth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthFacade {
  loaded$: Observable<boolean> = this.store.pipe(select(authQuery.getLoaded));
  user$: Observable<User> = this.store.pipe(select(authQuery.getUser));
  isAuthenticated$ = this.store.pipe(select(authQuery.isAuthenticated));
  error$ = this.store.pipe(select(authQuery.getError));
  loading$: Observable<boolean> = this.store.pipe(select(authQuery.getLoading));

  constructor(
    private store: Store<AuthPartialState>,
    private jwtService: JwtService
  ) { }

  hasValidAccessToken() {
    return this.jwtService.getToken();
  }

  login(authenicate: { username: string; password: string }): void {
    this.store.dispatch(new Login(authenicate));
  }

  getUserDetails(): void {
    this.store.dispatch(new GetUserDetails());
  }

  logout(): void {
    this.store.dispatch(new Logout());
  }
}
